import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'

import Api from './services/ApiService'
import LinkStore from './store/LinkStore';

// registerServiceWorker()

window.initBookingApp = function ({apiBaseUrl, apiKey, elementId, termsElementId}) {
    if (apiBaseUrl === undefined || apiBaseUrl !== '') {
        Api.configure({
            apiBaseUrl,
            apiKey
        })
    }
    
    LinkStore.setTermsElement(termsElementId)

    ReactDOM.render(<App />, document.getElementById(elementId))
}


// WEBPACK FOOTER //
// ./src/index.js